// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__i6sz9","title":"AfterBackImages_title__18sF0","images":"AfterBackImages_images__3D7Ic"};